var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "134",
        viewBox: "0 0 178 134",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0.000488281 133.106H177.149V0.000488281H0.000488281V133.106Z",
          fill: "#65BBE5",
        },
      }),
      _c("path", {
        attrs: {
          d: "M88.5737 133.106C137.492 133.106 177.148 103.309 177.148 66.5531C177.148 29.7969 137.492 0 88.5737 0C39.656 0 0 29.7969 0 66.5531C0 103.309 39.656 133.106 88.5737 133.106Z",
          fill: "#3297C9",
        },
      }),
      _c("path", {
        attrs: {
          d: "M88.5785 99.9044C113.081 99.9044 132.945 84.9792 132.945 66.5679C132.945 48.1567 113.081 33.2314 88.5785 33.2314C64.0753 33.2314 44.2119 48.1567 44.2119 66.5679C44.2119 84.9792 64.0753 99.9044 88.5785 99.9044Z",
          fill: "#65BBE5",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }